<template>
  <div class="sponsors">
    <h3>Empresas que apoiam a associação</h3>
    <div class="supporters">
      <span v-for="company in companies" :key="company.name">
        <img :src="company.logo" :alt="company.name" width="64" />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sponsors',
  data() {
    return {
      companies: [
        { name: 'Empresa A', logo: 'https://scontent-lis1-1.xx.fbcdn.net/v/t1.6435-9/104175276_2660039840981349_4780844697803631474_n.jpg?_nc_cat=106&ccb=1-7&_nc_sid=1d70fc&_nc_ohc=whR2jnjbBk4Q7kNvwGSGdWH&_nc_oc=Adlh8fqALFY-of0otpfrMJPEefVSCehLnxSkDyahrKY-BCwSNl__kSWrfBJGwqf_hEg&_nc_zt=23&_nc_ht=scontent-lis1-1.xx&_nc_gid=E5i9tU8Mg09IeWPotEj0HQ&_nc_ss=8&oh=00_AfxcvSF63HrpGqyti8NWVT0jp5OvTnBppyAcxRT4JEY0Yg&oe=69CE4A25' },
        { name: 'Empresa B', logo: 'https://scontent-lis1-1.xx.fbcdn.net/v/t1.6435-9/104175276_2660039840981349_4780844697803631474_n.jpg?_nc_cat=106&ccb=1-7&_nc_sid=1d70fc&_nc_ohc=whR2jnjbBk4Q7kNvwGSGdWH&_nc_oc=Adlh8fqALFY-of0otpfrMJPEefVSCehLnxSkDyahrKY-BCwSNl__kSWrfBJGwqf_hEg&_nc_zt=23&_nc_ht=scontent-lis1-1.xx&_nc_gid=E5i9tU8Mg09IeWPotEj0HQ&_nc_ss=8&oh=00_AfxcvSF63HrpGqyti8NWVT0jp5OvTnBppyAcxRT4JEY0Yg&oe=69CE4A25' },
        { name: 'Empresa C', logo: 'https://scontent-lis1-1.xx.fbcdn.net/v/t1.6435-9/104175276_2660039840981349_4780844697803631474_n.jpg?_nc_cat=106&ccb=1-7&_nc_sid=1d70fc&_nc_ohc=whR2jnjbBk4Q7kNvwGSGdWH&_nc_oc=Adlh8fqALFY-of0otpfrMJPEefVSCehLnxSkDyahrKY-BCwSNl__kSWrfBJGwqf_hEg&_nc_zt=23&_nc_ht=scontent-lis1-1.xx&_nc_gid=E5i9tU8Mg09IeWPotEj0HQ&_nc_ss=8&oh=00_AfxcvSF63HrpGqyti8NWVT0jp5OvTnBppyAcxRT4JEY0Yg&oe=69CE4A25' },
      ],
    };
  },
};
</script>

<style scoped>
.sponsors {
  background: #f7f7f7;
  padding: 2rem;
  text-align: center;
  width: 100%;
}
.supporters {
  margin-top: 1rem;
  display: flex;
  gap: 2rem;
  justify-content: center;
  flex-wrap: wrap;
}

@media (max-width: 480px) {
  .sponsors {
    padding: 1.5rem 1rem;
  }
  .supporters {
    gap: 1rem;
  }
}
</style>

